import axios from 'axios'

const login={
    state: {
      user: null,
      return_path: "",
    },
    mutations: {
      set_return(state, value){
        state.return_path = value;
      },
      login(state, value){
        state.user = value
        console.log("LOGIN")
      },
      logout(state){
        state.user = null
        state.return_path = "";
      },
      profile(state, value){
        state.user.profile = value
      }
    },
    actions: {
      logout(context,done){
        done();
        axios.post(`/api/profile/logout`).then(res=>{
          // console.log(state)
          // console.log(state.return_path)
          context.commit('logout');
          console.log("LOGOUT")
        }) 
      }
    }
  }
export default login